import { type UseQueryResult, useQuery } from 'react-query';
import {
  TermsAndConditionsService,
  TermsAndConditionsSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto,
} from '../../services/wealthlane-customer-services';

const useGetTermAndConditionOnboarding = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto[] | undefined,
  unknown
> => {
  const participantTermAndConditionOnboarding = useQuery(
    ['getTermAndConditionOnboarding'],
    async () => {
      return await handleRequest(
        TermsAndConditionsService.getApiCustomerApiTermsAndConditionsParticipantOnboarding()
      );
    }
  );

  return participantTermAndConditionOnboarding;
};

export default useGetTermAndConditionOnboarding;
